import React, { useState, useEffect, useRef } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import './product_sstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'aos/dist/aos.css';
import './productdetails.css';
import banner from '../img/logo/banner-bg.png';
import amogh from '../img/logo/amogh.png'
import top from '../img/logo/left_top.png';
import bottom from '../img/logo/left_bottom.png';
import right_top from '../img/logo/right_top.png';
import right_bottom from '../img/logo/right_bottom.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FiMail, FiPhone, FiArrowRight } from "react-icons/fi";
import 'react-medium-image-zoom/dist/styles.css';
import intro from "../img/products/speaklear_intro.gif";
import video_intro from "../img/products/video_intro.mp4";
import impo from "../img/products/impo.svg";
import usericon from "../img/products/user.svg";
import mobileicon from "../img/products/mobile.svg";
import emailicon from "../img/products/email.svg";
import Footer from "./Footer";

function Productdetails() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,         // ✅ ensures animation runs on scroll up too
      mirror: true,        // ✅ animates out while scrolling past
      easing: 'linear',
    });
  }, []);


  return (
  <>
  {/* <section class="one section_class">fg</section>
  <section class="two section_class">dfg</section>
  <section class="three section_class">dfg</section> */}


  <div className="snaparea" style={{ backgroundColor: "#FFFFF", padding: "0px", margin: "0 auto" }} >

  {/* <section class="one section_class">fg1</section>
  <section class="two section_class">dfg1</section>
  <section class="three section_class">dfg1</section> */}

{/* <section className="section_class mt-5" data-aos="zoom-in">
    <div className={`container_class_center container `} data-aos="fade-left">
      <div className="row">
       <div className="scroll-para">
        <h3 className="pt-5" >What is it?</h3>
        <p>Speaklear™ is a self learning speech training application software that can be used by individuals as well as speech therapists for their speech therapy.</p>
        <br /><br /><br /><br /><br /><br /><br /><br />
        </div>
        
      <div>
        <img className="right_corner" src="img/logo_b.png" alt="Design" width="100" />
      </div>
      
    </div>
  </div>
</section> */}

<section className="section_class mt-5" data-aos="fade-up">
<div className={`container_class_center container `}>
  <div className="row">
    <div className="col-lg-12">
      <div className="scroll-para">
        <h3 className="pt-5">What is it?</h3>
        <p>Speaklear™ is a self learning speech training application software that can be used by individuals as well as speech therapists for their speech therapy.</p>
      </div>
      <div className="scroll-para">
        <h3 className="pt-5">What are we doing?</h3>
        <p>We are the first player in the digital assistive speech training space for people with speech impairments. We tackle conventional challenges of speech therapy by providing a digital tool that facilitates and makes speech learning easier.</p>
      </div>
      <div className="scroll-para">
        <h3 className="pt-5">Challenges of conventional speech therapy:</h3>
        <ul>
          <li>Availability of diligent speech therapists</li>
          <li>Limited time provision per therapist per child</li>
          <li>Expensive fees and logistical issues</li>
          <li>Demands extra attention and care</li>
          <li>NO digital tools to facilitate speech learning in India</li>
        </ul>
      </div>
      <div>
        <img className="right_corner" src="img/logo_b.png" alt="Design" width="100" />
      </div>
    </div>
  </div>
</div>
</section>



{/* <section className="section_class mt-5" data-aos="zoom-in">
  <div className="container_class_center container ">
    <div className="row">
      <p className="slide-paragraph pt-5">
      <p data-aos="fade-right" data-aos-delay="50">Born with<br />hearing loss </p>
          <p data-aos="fade-right" data-aos-ease="ease-in" data-aos-delay="150"><FiArrowRight className="blue_color_arrow" /></p>
          <p data-aos="fade-right" data-aos-ease="ease-in" data-aos-delay="200">Mother’s<br /> training</p>
          <p data-aos="fade-right" data-aos-ease="ease-in" data-aos-delay="250"><FiArrowRight className="blue_color_arrow" /></p>
          <p data-aos="fade-right" data-aos-ease="ease-in" data-aos-delay="300">Personal<br /> Experience </p>
          <p data-aos="fade-right" data-aos-ease="ease-in" data-aos-delay="350"><FiArrowRight className="blue_color_arrow" /></p>
          <p data-aos="fade-right" data-aos-ease="ease-in" data-aos-delay="400"> New <br /> endeavour </p>
      </p>
      <div>
        <img className="right_corner" src="img/logo_b.png" alt="Design" width="100" />
      </div>
    </div>
  </div>
</section> */}


<section className="section_class mt-5" >
  <div className="container_class container ">
    <div className="row">
      <div className="col-lg-12">
        <p className="slide-paragraph pt-5">
          <p data-aos="fade-right" data-aos-delay="100">Born with<br />hearing loss </p>
          <p data-aos="fade-right" data-aos-delay="200"><FiArrowRight className="blue_color_arrow" /></p>
          <p data-aos="fade-right" data-aos-delay="500">Mother’s<br /> training</p>
          <p data-aos="fade-right" data-aos-delay="800"><FiArrowRight className="blue_color_arrow" /></p>
          <p data-aos="fade-right" data-aos-delay="1000">Personal<br /> Experience </p>
          <p data-aos="fade-right" data-aos-delay="1300"><FiArrowRight className="blue_color_arrow" /></p>
          <p data-aos="fade-right" data-aos-delay="1800"> New <br /> endeavour </p>
        </p>
        <h3 className="pt-5">The Why?</h3>
        <p>I was born with sensorineural congenital hearing loss. All throughout my childhood, my mother, Mrs. Shailaja, worked very hard in training me how to speak both English and Kannada which is incredible considering that I cannot learn languages by hearing. My parents are the reason I am here today, and completely independent of any speaking assistance. </p>
        <p>I empathise and understand the deep rooted issues for people with hearing and speech impairments as well as the challenges of conventional speech therapy. With personal experience and a dedicated support team, I have embarked on a new mission to enable, empower and engage with the challenged people to make speech learning easier. </p>
        <p>By merging new age Artificial Intelligence and Machine Learning technology with expert speech therapy resources, learning speech does not have to be all that difficult anymore.</p>
        <h5>-Amogh Inamdar</h5>
        <div>
        <img className="right_corner" src="img/logo_b.png" alt="Design" width="100" />
      </div>
      </div>
    </div>
  </div>
</section>



<section className="section_class" style={{backgroundColor: '#eef7fb'}}>
  <div className="container_class container ">
    <div className="row">
      <div className="chat_box mt-5">
        <img className="img-fluid" src="img/speech_graph.gif" alt="Rectangles" width="600" />
      </div>

      {/* <span className="inline_rectangle_text pt-3" style={{width: '48%', margin: '0 auto'}}>
        <span>Current Speech</span>
        <span className="inline-rectangle_1"></span>
        <span>Errors</span>
        <span className="inline-rectangle_2"></span>
        <span>Interim Standard</span>
        <span className="inline-rectangle_3"></span>
        <span>Global Standard</span>
        <span className="inline-rectangle_4"></span>
      </span> */}
      <h3 className="pt-3 text-center">&nbsp;</h3>
    </div>
  </div>
</section>

{/* <section className="section_class" data-aos="zoom-in-down"> 
  <div className="container_class container ">
    <div className="row">
      <div className="chat_box mt-5">
        <img src="img/chats_2.png" alt="Rectangles" width="600" />
      </div>
      <span className="inline_rectangle_text pt-3" style={{width: '48%', margin: '0 auto'}}>
        <span>Current Speech</span>
        <span className="inline-rectangle_1"></span>
        <span>Errors</span>
        <span className="inline-rectangle_2"></span>
        <span>Interim Standard</span>
        <span className="inline-rectangle_3"></span>
        <span>Global Standard</span>
        <span className="inline-rectangle_4"></span>
      </span>
      <h3 className="pt-3 inline_center_text text-center" data-aos="flip-up">Un-trained speech</h3>
    </div>
  </div>
</section> */}

{/* <section className="section_class" data-aos="zoom-in-down">
  <div className="container_class container ">
    <div className="row">
      <div className="chat_box mt-5">
        <img src="img/chats_3.png" alt="Rectangles" width="600" />
      </div>
      <span className="inline_rectangle_text pt-3" style={{width: '48%', margin: '0 auto'}}>
        <span>Current Speech</span>
        <span className="inline-rectangle_1"></span>
        <span>Errors</span>
        <span className="inline-rectangle_2"></span>
        <span>Interim Standard</span>
        <span className="inline-rectangle_3"></span>
        <span>Global Standard</span>
        <span className="inline-rectangle_4"></span>
      </span>
      <h3 className="pt-3 inline_center_text text-center" data-aos="flip-up">Trained routine</h3>
    </div>
  </div>
</section> */}

{/* <section className="section_class" data-aos="zoom-in-down">
  <div className="container_class container ">
    <div className="row">
      <div className="chat_box mt-5">
        <img src="img/chats_4.png" alt="Rectangles" width="600" />
      </div>
      <span className="inline_rectangle_text pt-3" style={{width: '48%', margin: '0 auto'}}>
        <span>Current Speech</span>
        <span className="inline-rectangle_1"></span>
        <span>Errors</span>
        <span className="inline-rectangle_2"></span>
        <span>Interim Standard</span>
        <span className="inline-rectangle_3"></span>
        <span>Global Standard</span>
        <span className="inline-rectangle_4"></span>
      </span>
      <h3 className="pt-3 inline_center_text text-center" data-aos="flip-up">Achieved speech</h3>
    </div>
  </div>
</section> */}

<section className="section_class">
  <div className="row">
    <div className="chat_box mt-5" >
      <img className="img-fluid" src="img/logo.png" alt="logo" width="350" />
    </div>
    <h3 className="pt-3 text-center">Speech learning, now easier.</h3>
  </div>
</section>


{/* <section className="section_class">
  <div className="row">
    <div className="image-containerf" data-aos="zoom-in-up">
      <div className="rectangle " data-aos="zoom-in-up">
        <img data-aos="zoom-in-down" src="img/design.png" alt="Design" />
      </div>
    </div>
  </div>
</section> */}

<div style={{backgroundColor: '#4072DD'}} >

<section className="section_class" style={{backgroundColor:'#4072DD'}} >
  <img className="Vector_img" src="img/Vector.png" alt="Design" data-aos="zoom-out-right" data-aos-offset="300"
     data-aos-easing="ease-in-sine" />
  <div className="container_class container ">
   <div className="row">
    <div className="col-lg-8 ">
      <h4 className="hearing_h5 pt-5" data-aos="fade-right" style={{ textAlign : 'left' }}>A speech mastering tool for people <br /> with speech impairments.</h4>
      <h2 className="sprre pt-3" data-aos="fade-right" data-aos-delay="1000">Speak. Practise. Repeat.</h2>
      <div>
        <img className="white_logo" src="img/white_logo.png" alt="Design" width="100" />
      </div>
    </div>
    <div className="col-lg-4" style={{zindex: '999', marginTop: '5%'}}>
      <img data-aos="zoom-in-up" src="img/mobile_screen.png" alt="Design" width="250" />
    </div>
  </div>
</div>
</section>

</div>



<div style={{backgroundColor: '#398A7C'}}>

<section className="section_class mt-5" style={{backgroundColor:'#398A7C'}}>
  <img className="Vector_img" src="img/Vector1.png" alt="Design" data-aos="zoom-out-right" data-aos-offset="300"
     data-aos-easing="ease-in-sine" />
  <div className="container_class container ">
   <div className="row">
    <div className="col-lg-8">
      <h4 className="hearing_h5 pt-5" data-aos="fade-right" style={{ textAlign : 'left' }}>With a separate interface for <br /> parents and therapists.</h4>
      <h2 className="sprre pt-3" data-aos="fade-right" data-aos-delay="1000">Teach. Record. Repeat.</h2>
      <div>
        <img className="white_logo" src="img/white_logo.png" alt="Design" width="100" />
      </div>
    </div>
    <div className="col-lg-4" style={{zindex: '999', marginTop: '5%'}}>
      <img data-aos="zoom-in-up" src="img/mobile_screen_green.png" alt="Design" width="250" />
    </div>
  </div>
</div>
</section>


</div>


{/* <section className="section_class mt-5" style={{backgroundColor:'#F2F8FF'}} data-aos="zoom-in" data-aos-easing="linear" data-aos-mirror="true" data-aos-once="false">
  <div className="container_class_center container  ">
    <div className="row">
      <div className="col-lg-8">
        <h4 className="hearing_h4 pt-5" data-aos="fade-right" style={{ textAlign : 'left' }}>With personal speech recognition,<br /> visual cues and machine learning.</h4>
        <div>
          <img className="white_logo" src="img/logo_b.png" alt="Design" width="100" />
        </div>
      </div>
      <div className="col-lg-4" style={{zindex: '999'}}>
        <img src="img/recoding.png" alt="Design" width="250" />
      </div>
    </div>
  </div>  
</section> */}


<section className="section_class mt-5" style={{backgroundColor:'#f0f6fd'}}>
  <div className="container_class_center container">
    <div className="row">
      <div className="col-lg-8">
        <h4 className="hearing_h4 pt-5" data-aos="fade-right" style={{ textAlign : 'left' }}>With personal speech recognition,<br /> visual cues and machine learning.</h4>
        <h2 className="sprre_blue pt-3" data-aos="fade-right" data-aos-delay="1000">Speak. Watch. Repeat.</h2>
        <div>
          <img className="white_logo" src="img/logo_b.png" alt="Design" width="100" />
        </div>
      </div>
      <div className="col-lg-4" style={{zindex: '999'}}>
        <img src="img/new_gif.gif" alt="Design" width="400" />
      </div>
    </div>
  </div> 
</section>


<div style={{backgroundColor: '#4A73CD'}}>

{/* <section className="section_class mt-5" style={{backgroundColor:'#4A73CD'}}>
  <div className="container_class container ">
    <div className="row">
      <h4 className="" style={{color: '#fff', paddingTop: '140px'}}>This is our journey. </h4>
      <div className="row">
        <div className="col-lg-4 bottom-yello-dashed" data-aos="fade-right">
        <h4 className="pt-5" style={{color: '#fff'}}>2020</h4>
        <p style={{color: '#fff'}}>It started as an M.Des course academic design research project ‘<b>Unmute Speech</b>’ at IDC, IIT Bombay.</p>

        <div className="rectangle_c mt-5"></div>
      </div>
      </div>
    </div>
    
  </div> 
</section> */}

{/* <section className="section_class mt-5" style={{backgroundColor:'#4A73CD'}} data-aos="zoom-in">
  <div className="container_class container ">
    <div className="row">
      <h4 className="" style={{color: '#fff', paddingTop: '140px'}}>This is our journey. </h4>
      <div className="row">
          <div className="col-lg-4 bottom-yello-dashed">
            <h4 className="pt-5" style={{color: '#fff'}}>2020</h4>
            <p style={{color: '#fff'}}>It started as an M.Des course academic design research project ‘<b>Unmute Speech</b>’ at IDC, IIT Bombay.</p>
            <div className="rectangle_c mt-5"></div>
      </div>

    <div className="col-lg-4 bottom-yello-dashed" data-aos="fade-right">
            <h4 className="pt-5" style={{color: '#fff'}}>2022</h4>
            <p style={{color: '#fff'}}>Entered into AICTE All India YUKTI Innovative Startups Competition and was selected as one of the key social projects to receive seed grant from the Govt. of India.</p>
            <div className="rectangle_c mt-5"></div>
        </div>
      </div>
  
    </div>
  </div> 
</section> */}

<section className="section_class mt-5" style={{backgroundColor:'#4A73CD'}} >
  <div className="container_class container ">
    <div className="row">
      <h4 className="" style={{color: '#fff', paddingTop: '140px'}}>This is our journey. </h4>
      <div className="row">
        <div className="col-lg-4 bottom-yello-dashed">
            <h4 className="pt-5" style={{color: '#fff'}}>2020</h4>
            <p style={{color: '#fff'}}>It started as an M.Des course academic design research project ‘<b>Unmute Speech</b>’ at IDC, IIT Bombay.</p>
            <div className="rectangle_c mt-5"></div>
        </div>

        <div className="col-lg-4 bottom-yello-dashed" data-aos="fade-right">
            <h4 className="pt-5" style={{color: '#fff'}}>2022</h4>
            <p style={{color: '#fff'}}>Entered into AICTE All India YUKTI Innovative Startups Competition and was selected as one of the key social projects to receive seed grant from the Govt. of India.</p>
            <div className="rectangle_c mt-5"></div>
        </div>

        <div className="col-lg-4 bottom-yello-dashed" data-aos="fade-right" data-aos-delay="1000">
            <h4 className="pt-5" style={{color: '#fff'}}>2024-2025</h4>
            <p style={{color: '#fff'}}>Formally registered
            a startup AblePro Solutions to establish and transition our work into a viable product, ‘Speaklear’.</p>
            <div className="rectangle_c mt-5"></div>
            <FiArrowRight className="corner-icon" />
        </div>
      </div>
    </div>
  </div> 
</section>

</div>

<section className="section_class" data-aos="fade-up">
  <div className="container_class container ">
  <div className="row">
    <div className="chat_box mt-20" style={{paddingTop: '150px'}} >
      <img src="img/logo_b.png" alt="logo" width="300" />
    </div>
    <h3 className="pt-3" style={{ textAlign : 'center' }}>needs your voice* to make it happen.</h3>
    {/* <button type="button" className="btn btn-outline-primary mt-5" style={{width:'20%', margin: '0 auto'}}>Download App</button> */}
    <p style={{textAlign:'center', paddingTop: '150px'}} className="bounce-in">*Non standard speech. Speech that is unclear, atypical or difficult to understand.</p>
  </div>
</div>
</section>
</div>
  </>
  )
}

export default Productdetails
